// Constantes de autenticação
const CLIENT_ID = '588251965114-1v8fbg3mf46ufdb3edrhcom2j6ksml8u.apps.googleusercontent.com';
const REDIRECT_URI = window.location.origin + '/oauth2callback';
const SCOPES = [
  'https://www.googleapis.com/auth/spreadsheets',
  'https://www.googleapis.com/auth/drive.file'
].join(' ');

export class GoogleService {
  private static instance: GoogleService;
  private accessToken: string | null = null;

  private constructor() {}

  public static getInstance(): GoogleService {
    if (!GoogleService.instance) {
      GoogleService.instance = new GoogleService();
    }
    return GoogleService.instance;
  }

  private async handleAuthCallback(): Promise<string> {
    return new Promise((resolve, reject) => {
      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
        `client_id=${CLIENT_ID}` +
        `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
        `&response_type=token` +
        `&scope=${encodeURIComponent(SCOPES)}`;

      const popup = window.open(
        authUrl,
        'Autorização Google',
        'width=600,height=600'
      );

      const checkClosed = setInterval(() => {
        if (popup?.closed) {
          clearInterval(checkClosed);
          reject(new Error('Janela de autorização fechada'));
        }
      }, 1000);

      window.addEventListener('message', async (event) => {
        if (event.origin !== window.location.origin) return;

        try {
          const params = new URLSearchParams(event.data.split('#')[1]);
          const accessToken = params.get('access_token');
          
          if (!accessToken) {
            throw new Error('Token de acesso não encontrado');
          }

          this.accessToken = accessToken;
          localStorage.setItem('googleAccessToken', accessToken);
          
          clearInterval(checkClosed);
          popup?.close();
          resolve(accessToken);
        } catch (error) {
          clearInterval(checkClosed);
          popup?.close();
          reject(error);
        }
      });
    });
  }

  public async authorize(): Promise<void> {
    try {
      const token = localStorage.getItem('googleAccessToken');
      if (token) {
        // Verifica se o token ainda é válido
        try {
          const response = await fetch('https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=' + token);
          if (response.ok) {
            this.accessToken = token;
            return;
          }
        } catch {
          localStorage.removeItem('googleAccessToken');
        }
      }

      await this.handleAuthCallback();
    } catch (error) {
      console.error('Erro na autorização:', error);
      throw new Error('Falha na autorização com o Google');
    }
  }

  public async createSpreadsheet(title: string, data: any[][]): Promise<string> {
    try {
      await this.authorize();

      if (!this.accessToken) {
        throw new Error('Não autorizado');
      }

      // Cria a planilha
      const createResponse = await fetch('https://sheets.googleapis.com/v4/spreadsheets', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          properties: {
            title,
            locale: 'pt_BR',
          },
          sheets: [{
            properties: {
              gridProperties: {
                frozenRowCount: 1
              }
            }
          }]
        })
      });

      if (!createResponse.ok) {
        throw new Error('Erro ao criar planilha');
      }

      const { spreadsheetId } = await createResponse.json();

      // Atualiza os dados
      const range = `A1:${String.fromCharCode(65 + data[0].length - 1)}${data.length}`;
      const updateResponse = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${range}?valueInputOption=RAW`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            values: data
          })
      });

      if (!updateResponse.ok) {
        throw new Error('Erro ao atualizar dados da planilha');
      }

      // Formata o cabeçalho
      const formatResponse = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            requests: [
              {
                repeatCell: {
                  range: {
                    startRowIndex: 0,
                    endRowIndex: 1,
                  },
                  cell: {
                    userEnteredFormat: {
                      backgroundColor: { red: 0.2, green: 0.2, blue: 0.2 },
                      textFormat: {
                        foregroundColor: { red: 1, green: 1, blue: 1 },
                        bold: true,
                      },
                    },
                  },
                  fields: 'userEnteredFormat(backgroundColor,textFormat)',
                },
              },
              {
                autoResizeDimensions: {
                  dimensions: {
                    sheetId: 0,
                    dimension: 'COLUMNS',
                    startIndex: 0,
                    endIndex: data[0].length,
                  },
                },
              },
            ],
          })
        }
      );

      if (!formatResponse.ok) {
        console.warn('Erro ao formatar planilha');
      }

      return `https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit`;
    } catch (error) {
      console.error('Erro ao criar planilha:', error);
      throw new Error('Não foi possível criar a planilha no Google Sheets');
    }
  }
}